import React from "react";
import TextExpand from "../../../components/TextExpand";

const markdownToHtml = text => {
  if (!text) return "";

  return (
    text
      // Преобразуем **текст** в <strong>текст</strong>
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      // Преобразуем *текст* в <em>текст</em>
      .replace(/\*(.*?)\*/g, "<em>$1</em>")
      // Преобразуем `текст` в <code>текст</code>
      .replace(/`(.*?)`/g, "<code>$1</code>")
      // Преобразуем [текст](ссылка) в <a href="ссылка">текст</a>
      .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>')
  );
};

const SeoSection = ({ seoHtml }) => {
  if (!seoHtml) return null;

  // Сначала преобразуем markdown в HTML, затем очищаем от лишних тегов
  const cleanHtml = markdownToHtml(seoHtml)
    .replace(/<\/?(tr|td|div|span)[^>]*(>|$)/gi, "")
    .replace(/<h2>/g, '<h2 class="TextExpand__heading">')
    .replace(/<ul>/g, '<ul class="TextExpand__list">')
    .replace(/<li>/g, '<li class="TextExpand__list-item">');

  return (
    <TextExpand html allowOriginalFormat shortText={cleanHtml.slice(0, 300)} fullText={cleanHtml} />
  );
};

export default SeoSection;
